<template>
  <div class="main situation">
      <div style="height: 100%">
          <div class="leftContent">
              <el-form :model="model" status-icon :rules="rules" ref="ruleForm">
                  <el-collapse v-model="activeNamesFirst">
                      <el-collapse-item title="个人信息" name="1">
                          <div class="tableContent">
                              <div class="row-item h-49">
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div><i class="required">*</i>所属单位</div>
                                          </div>
                                          <div class="right h32">
                                              <el-form-item prop="organizationId">
                                                  <el-select placeholder="全部" class="" v-model="model.organizationId" style="width:100%; margin-right:0px">
                                                      <el-option v-for="item in organizationList" :key="item.id" :label="item.simpName" :value="item.id">
                                                      </el-option>
                                                  </el-select>
                                              </el-form-item>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div><i class="required">*</i>账号</div>
                                          </div>
                                          <div class="right h32">
                                              <el-form-item prop="username">
                                                  <el-input class="" v-model="model.username" type="text" placeholder="请输入账号"></el-input>
                                              </el-form-item>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row-item h-49">
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div><i class="required">*</i>密码</div>
                                          </div>
                                          <div class="right h32">
                                              <el-form-item prop="password">
                                                  <el-input v-model="model.password" :disabled="!checked&&!!val.id" class="" type="password" show-password placeholder="请输入密码" @blur="passwordBlur"></el-input>
                                              </el-form-item>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div><i class="required">*</i>确认密码</div>
                                          </div>
                                          <div class="right h32">
                                              <el-form-item prop="checkPass">
                                                  <el-input class=" margin-right-15" :disabled="!checked&&!!val.id" v-model="model.checkPass" type="password" show-password placeholder="请输入确认密码"></el-input>
                                              </el-form-item>
                                              <el-checkbox v-if="!!val.id" v-model="checked">重置密码</el-checkbox>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row-item h-49">
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div><i class="required">*</i>姓名</div>
                                          </div>
                                          <div class="right h32">
                                              <el-form-item prop="realname">
                                                  <el-input class="" v-model="model.realname" type="text" placeholder="请输入姓名"></el-input>
                                              </el-form-item>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div><i class="required">*</i>手机号</div>
                                          </div>
                                          <div class="right h32">
                                              <el-form-item prop="phone">
                                                  <el-input class="" v-model="model.phone" type="text" placeholder="请输入手机号"></el-input>
                                              </el-form-item>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row-item h-49">
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div>性别</div>
                                          </div>
                                          <div class="right h32">
                                              <el-radio v-model="model.gender" label="1">男</el-radio>
                                              <el-radio v-model="model.gender" label="2">女</el-radio>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div><i class="required">*</i>身份证号码</div>
                                          </div>
                                          <div class="right h32">
                                              <el-form-item prop="identityCardNo">
                                                  <el-input class="" v-model="model.identityCardNo" type="text" placeholder="请输入身份证号"></el-input>
                                              </el-form-item>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row-item h-49">
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div>警员号</div>
                                          </div>
                                          <div class="right h32">
                                              <el-input class="" v-model="model.policeNo" type="text" placeholder="请输入警员号"></el-input>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div>账号状态</div>
                                          </div>
                                          <div class="right h32">
                                              {{model.block}}
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row-item h-49">
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div>所属保险公司</div>
                                          </div>
                                          <div class="right h32">
                                              <el-input type="text" v-model="model.insuranceCompanyName" @click.native="insuranceShow=true"></el-input>
                                              <el-button style="margin-left:15px;" type="danger" size="mini" plain @click="removeCompanyName">删除</el-button>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div>岗位角色</div>
                                          </div>
                                          <div class="right h32 checkcase">
                                              <el-checkbox-group v-model="roleNames">
                                                  <el-checkbox v-for="item in roleCheckList" :label="item.roleName" :key="item.id" :disabled="item.isDisabled"></el-checkbox>
                                              </el-checkbox-group>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row-item h-49">
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div>角色身份</div>
                                          </div>
                                          <div class="right h32">
                                              <input class="input margin-right-15" v-model="districtNames" :disabled="true" type="text" placeholder="请输入角色身份">
                                              <el-button type="primary" @click="selectRoles">选择角色身份</el-button>
                                              <span class="ml12">
                                                  <el-checkbox v-model="dingzePoliceAuth" label="定责民警"></el-checkbox>
                                              </span>
                                              <span class="ml12">
                                                  <el-checkbox v-model="enforcementPoliceAuth" label="执勤辅警"></el-checkbox>
                                              </span>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row-item h-49">
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div>文书修改</div>
                                          </div>
                                          <div class="right h32">
                                              <el-checkbox v-model="accidentEditAuth" label="修改申请"></el-checkbox>
                                              <el-checkbox v-model="accidentExamineAuth" label="修改审批"></el-checkbox>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div>审批领导</div>
                                          </div>
                                          <div class="right h32">
                                              <input class="input margin-right-15" v-model="model.examineLeaderName" type="text" placeholder="请选择审批领导">
                                              <el-button type="primary" @click="selectLeader">选择审批领导</el-button>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row-item h-49">
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div>安全验证</div>
                                          </div>
                                          <div class="right h32">
                                              <el-checkbox label="人脸核验" v-model="faceDisabled"></el-checkbox>
                                              <el-checkbox v-model="needAuthConfirm" label="授权码核验"></el-checkbox>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row-item h-100">
                                  <div class="row">
                                      <div class="column">
                                          <div class="left">
                                              <div>授权码</div>
                                          </div>
                                          <div class="right h32">
                                              <el-input type="textarea" placeholder="请输入授权码" v-model="model.authorizationDevice" maxlength="120" resize="none" show-word-limit>
                                              </el-input>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </el-collapse-item>
                  </el-collapse>
                  <el-collapse v-model="activeNamesThird">
                      <el-collapse-item title="图章上传" name="1">
                          <div class="wholeAcccindentClass">
                              <div class="accidentImages">
                                  <div class="images">
                                      <div class="img-box">
                                          <div v-if="accidentImg">
                                              <div class="video-wrap" v-if="/(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)$/.test(accidentImg)">
                                                  <i></i>
                                              </div>
                                              <img :src="getImageUrl(accidentImg,'')" alt="" @click="previewImg(accidentImg)" />
                                          </div>
                                          <div class="img-mask-no" v-else>
                                              <i class="el-icon-upload" v-if="!accidentImg"></i>
                                              <i class="el-icon-zoom-in" @click="previewImg(accidentImg)" v-else></i>
                                              <div v-if="!accidentImg">上传图片</div>
                                          </div>
                                      </div>
                                      <el-upload ref="upload" class="upload-demo" accept=".jpg,.jpeg,.png" :action="action" :auto-upload="false" :headers="headers" :show-file-list="false" :on-change="handleChange" :before-upload="beforeUpload" :on-success="uploadSuccess">
                                          <el-button size="small" type="primary">点击上传</el-button>
                                      </el-upload>
                                  </div>
                              </div>
                          </div>
                      </el-collapse-item>
                  </el-collapse>
                  <el-collapse v-model="activeNames">
                      <el-collapse-item title="警民联系" name="1">
                          <div class="wholeAcccindentClass">
                              <div class="accidentImages">
                                  <div class="images">
                                      <div class="img-box">
                                          <div v-if="contactImg">
                                              <div class="video-wrap" v-if="/(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)$/.test(contactImg)">
                                                  <i></i>
                                              </div>
                                              <img :src="getImageUrl(contactImg, 1)" alt="" @click="previewImg(contactImg)" />
                                          </div>
                                          <div class="img-mask-no" v-else>
                                              <i class="el-icon-upload" v-if="!contactImg"></i>
                                              <i class="el-icon-zoom-in" @click="previewImg(contactImg)" v-else></i>
                                              <div v-if="!contactImg">上传图片</div>
                                          </div>
                                      </div>
                                      <el-upload ref="upload_contact" class="upload-demo" accept=".jpg,.jpeg,.png" :action="action_contact" :auto-upload="false" :headers="headers" :show-file-list="false" :on-change="handleChange_contact" :before-upload="beforeUpload_contact" :on-success="uploadSuccess_contact">
                                          <el-button size="small" type="primary">点击上传</el-button>
                                      </el-upload>
                                  </div>
                              </div>
                          </div>
                      </el-collapse-item>
                  </el-collapse>
              </el-form>
          </div>
      </div>
      <div class="bottomBtns">
          <el-button type="primary" @click="saveInformation('ruleForm')">保存</el-button>
          <el-button plain @click="back()">返回</el-button>
      </div>
      <transition name="el-zoom-in-center">
          <role @func="getRoleSon" @getDatas="getRoleDatas" v-bind:roleIds="districtIds" v-bind:organizationId="model.organizationId" v-if="roleShow"></role>
      </transition>
      <transition name="el-zoom-in-center">
          <insurance v-if="insuranceShow" @func="getRoleSon3"></insurance>
      </transition>
      <transition name="el-zoom-in-center">
          <leader v-if="leaderShow" @func="getRoleSon2" :namesIds="model.examineLeaderIds"></leader>
      </transition>
  </div>
</template>
  
  <script>
  import insurance from './components/insurance'
  import role from './components/role'
  import leader from './components/leader'
  import config from "@/common/env.js";
  export default {
      props: {
          val: Object
      },
      name: 'claim-detail',
      data() {
          var testPassword = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&_\(\)\^])[A-Za-z\d$@$!%*#?&_\(\)\^]{6,}$/;
          var validateOrganizationId = (rule, value, callback) => {
              if (value == null || value == '') {
                  callback(new Error('请选择所属单位'));
              } else {
                  callback();
              }
          };
          var validateUsername = (rule, value, callback) => {
              if (value == null || value == '') {
                  callback(new Error('请输入账号'));
              } else {
                  callback();
              }
          };
          var validatePass = (rule, value, callback) => {
              if (value == null || value == '') {
                  callback(new Error('请输入密码'));
              } else if (!testPassword.test(value)) {
                  callback(new Error('新密码需要包含字母+数字+字符'));
              } else {
                  callback();
              }
          };
          var validatePass2 = (rule, value, callback) => {
              if (value == null || value == '') {
                  callback(new Error('请再次输入密码'));
              } else if (value != this.model.password) {
                  console.log(value, this.model.password)
                  callback(new Error('两次输入密码不一致!'));
              } else {
                  callback();
              }
          };
          var validateRealname = (rule, value, callback) => {
              if (value == null || value == '') {
                  callback(new Error('请输入姓名'));
              } else {
                  callback();
              }
          };
          var validatePhone = (rule, value, callback) => {
              let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
              if (value == null || value == '') {
                  callback(new Error('请输入手机号'));
              } else if (!reg.test(value)) {
                  callback(new Error('手机号格式不正确'));
              } else {
                  callback();
              }
          };
          var validateIdentityCardNo = (rule, value, callback) => {
              let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
              if (value == null || value == '') {
                  callback(new Error('请输入身份证号'));
              } else if (!reg.test(value)) {
                  callback(new Error('身份证号格式不正确'));
              } else {
                  callback();
              }
          };
          return {
              faceDisabled: 0, //是否需要设备验证0不需要，1需要
              activeNamesFirst: ['1'],
              activeNamesThird: ['1'],
              testImg: 'https://img1.baidu.com/it/u=2725256892,1346976217&fm=26&fmt=auto&gp=0.jpg',
              accidentImg: '',
              value: 3.7,
              manageShow: false,
              approvalShow: false,
              climateList: [],
              textarea: '',
              checked: false,
              insuranceShow: false,
              roleShow: false,
              selectedRole: null, //选择的身份名称
              leaderShow: false,
              radio: 1,
              accidentEditAuth: null,
              accidentExamineAuth: null,
              needAuthConfirm: null,
              districtIds: null, //角色身份id
              districtNames: null, //角色身份
              roleIds: [], //岗位角色-名称id,逗号分隔
              roleNames: [], //岗位角色-名称，逗号分隔，和id顺序对应
              roleCheckList: [],
              roleCheck: [],
              dingzePoliceAuth: null,
              enforcementPoliceAuth: null,
              model: {
                  checkPass: null,
                  authorizationDevice: null, //可登录设备token，逗号分隔
                  gender: '1', //性别，0女1男
                  identityCardNo: null, //身份证号
                  needAuthConfirm: 0, //是否需要设备验证0不需要，1需要
                  organizationId: null, //number 组织id
                  password: null, //string 密码
                  phone: null, //string 电话
                  policeNo: null, //string 警员编号
                  realname: null, //string 真名
                  username: null, //string 用户名
                  block: null, //锁定状态
                  insuranceCompanyName: null,
                  insuranceCompanyId: null,
                  accidentEditAuth: null, //修改申请
                  accidentExamineAuth: null, //修改审批
                  dingzePoliceAuth: null, //进入民警列表,
                  enforcementPoliceAuth: null,
                  examineLeaderIds: null,
                  examineLeaderName: null,
                  policeStampUrl: null, //图片url
                  policeContactUrl: null,
              },
              imgurl: null,
              detail: false,
              organizationList: [],
              insuranceCompanyList: [],
              ruleForm: {
                  pass: '',
                  checkPass: '',
                  username: '',
                  realname: '',
              },
              rules: {
                  organizationId: [{
                      validator: validateOrganizationId,
                      trigger: 'change'
                  }],
                  username: [{
                      validator: validateUsername,
                      trigger: 'blur'
                  }],
                  password: [{
                      validator: validatePass,
                      trigger: 'blur'
                  }],
                  checkPass: [{
                      validator: validatePass2,
                      trigger: 'blur'
                  }],
                  realname: [{
                      validator: validateRealname,
                      trigger: 'blur'
                  }],
                  phone: [{
                      validator: validatePhone,
                      trigger: 'blur'
                  }],
                  identityCardNo: [{
                      validator: validateIdentityCardNo,
                      trigger: 'blur'
                  }],
              },
              rules2: {
                  organizationId: [{
                      validator: validateOrganizationId,
                      trigger: 'change'
                  }],
                  username: [{
                      validator: validateUsername,
                      trigger: 'blur'
                  }],
                  password: [{
                      validator: validatePass,
                      trigger: 'blur'
                  }],
                  checkPass: [{
                      validator: validatePass2,
                      trigger: 'blur'
                  }],
                  realname: [{
                      validator: validateRealname,
                      trigger: 'blur'
                  }],
                  phone: [{
                      validator: validatePhone,
                      trigger: 'blur'
                  }],
                  identityCardNo: [{
                      validator: validateIdentityCardNo,
                      trigger: 'blur'
                  }],
              }, //重置密码时校验用
              leaderList: null,
              headers: {
                  "TR-TOKEN": JSON.parse(localStorage.getItem('userinfos')).token
              },
              uploadState: false,
              imgList: [], //当前图片src数组
              imgIndex: 0, //当前选择的哪张图片
              uploadListConfig: [],
              action: '',
              activeNames: ['1'],
              action_contact: "",
              contactImg: "",
              uploadState_contact: false,
  
          }
      },
      watch: {
          'model.insuranceCompanyId'(newVal) {
              // console.log(newVal)
              if (newVal) {
                  if (this.insuranceCompanyList.length > 0) {
                      this.insuranceCompanyList.forEach(item => {
                          if (item.id == newVal) {
                              this.model.insuranceCompanyName = item.insuranceCompanyName
                          }
                      })
                  } else {
                      this.loadInsList().then(res => {
                          this.insuranceCompanyList.forEach(item => {
                              if (item.id == newVal) {
                                  this.model.insuranceCompanyName = item.insuranceCompanyName
                              }
                          })
                      })
                  }
              }
          },
          checked: {
              handler(val) {
                  // console.log(val)
                  if (val) {
                      this.rules = this.rules2
                  } else if (this.val.id != null && val == false) {
                      delete this.rules.password
                      delete this.rules.checkPass
                  }
                  console.log(this.rules)
              },
              immediate: true
          },
          'model.organizationId': {
              handler(val) {
                  console.log(val)
                  if (val != null) {
                      this.getroleList(val)
                  }
              },
              immediate: true
          },
  
      },
      components: {
          insurance,
          role,
          leader,
      },
      created() {
          this.action = this.CODE_SERVER + '/admin/user/uploadFile'; //图片上传地址
          this.action_contact = this.CODE_SERVER + '/admin/user/uploadContact'; //警民联系方式图片上传地址
  
          this.loadInsList()
          this.getleaderList()
          this.loadLeaderList()
          this.getOrganizationList()
      },
      computed: {},
      mounted() {
          localStorage.setItem('newDe', 1);
          setTimeout(() => {
            //   this.query()
          }, 500)
      },
      methods: {
        getImageUrl(url, type) {
            let str = type ? "/file/server/file" : "/file/server/decrypt/file";
            return `${config.baseUrl}${str}?path=${encodeURI(url)}`;
        },
          //图片上传
          handleChange(file) {
              console.log(file)
              console.log(this.val.id)
              // if(this.uploadState) return
              if (this.val.id == null) return this.$message.error("请先保存基本信息")
              // if(this.model.policeStampUrl != null) return this.$message.error("最多只能上传1个文件")
              this.$refs.upload.submit();
          },
          beforeUpload(file) {
  
          },
          uploadSuccess(res, file) {
              console.log(res)
              if (res.data) {
                  this.accidentImg =res.data.url
                  this.model.policeStampUrl = res.data.url
                  this.uploadState = true
              }
          },
          handleChange_contact(file) {
              console.log(file)
              console.log(this.val.id)
              // if(this.uploadState_contact) return
              if (this.val.id == null) return this.$message.error("请先保存基本信息")
              // if(this.model.policeContactUrl != null) return this.$message.error("最多只能上传1个文件")
              this.$refs.upload_contact.submit();
          },
          beforeUpload_contact(file) {
  
          },
          uploadSuccess_contact(res, file) {
              console.log(res)
              if (res.data) {
                  // this.contactImg = URL.createObjectURL(file.raw);
                  this.contactImg = res.data.url
                  this.model.policeContactUrl = res.data.url
                  this.uploadState_contact = true
              }
          },
  
          getRoleSon2(data) {
              this.leaderShow = false
              if (data == false) return
              let datas = JSON.parse(data)
              this.model.examineLeaderIds = datas.realid
              this.model.examineLeaderName = datas.realname
          },
          getRoleSon3(data) {
              this.insuranceShow = false
              if (data == false) return
              let datas = JSON.parse(data)
              this.model.insuranceCompanyName = datas.insuranceCompanyName
              this.model.insuranceCompanyId = datas.id
          },
          //岗位角色
          loadLeaderList() {
              this.$axios.get('/admin/role/simpList').then(res => {
                  let data = this.AppUtils.checkResponse(res);
                  if (data) {
                      let userRoles = JSON.parse(localStorage.getItem('userinfos')).username;
                      console.log(userRoles)
                      data.data.forEach(item => {
                          item.isDisabled = false
                          if (userRoles != 'admin' && (item.roleName == "超级管理员" || item.roleName == "案件查询")) {
                              item.isDisabled = true
                          }
                      })
                      this.roleCheckList = data.data
                  }
              })
          },
  
          /*  previewImg(url) {
               let that=this;
                 if(this.$store.state.previewImgUrl){
                   this.$store.commit("SHOW_PREVIEW_IMG", '')
                 }
                 setTimeout(() => {
                   that.$store.commit("SHOW_PREVIEW_IMG", url);
                 }, 500);
             }, */
          previewImg(url) {
              let that = this;
              if (this.$store.state.previewImgUrl) {
                  this.$store.commit("SHOW_PREVIEW_IMG", '')
              }
              let data = []
              if(this.accidentImg){
                data.push(this.accidentImg);
              }
              if(this.contactImg){
                data.push('my_staff' + this.contactImg);
              }
              let myIndex=data.findIndex(res=>res==url);
              console.log(data)
              console.log(url)
              setTimeout(() => {
                  localStorage.setItem('myIndex', myIndex);
                  localStorage.setItem('myPics', JSON.stringify(data));
                  that.$store.commit('SHOW_PREVIEW_IMG', url)
              }, 1000);
          },
  
          //获取选择的身份信息
          getRoleDatas(data) {
              console.log(data)
              let nameArr = []
              let idArr = []
              if (data.length > 0) {
                  data.forEach(item => {
                      nameArr.push(item.label)
                      idArr.push(item.id)
                  })
                  this.districtNames = nameArr.toString();
                  this.districtIds = idArr.toString();
              } else {
                  this.districtNames = null;
                  this.districtIds = null;
              }
          },
          getRoleSon(data) {
              this.roleShow = data
              console.log(data)
          },
          getOrganizationList() {
              this.$axios.get('/admin/organization/simpList').then(res => { //所属单位
                  let data = this.AppUtils.checkResponse(res);
                  if (data) {
                      this.organizationList = data.data
                  }
              })
          },
          loadInsList() {
              return new Promise((resolve, reject) => {
                  this.$axios.get('/admin/insuranceCompany/simpList').then(res => { //保险公司
                      if (res.data) {
                          this.insuranceCompanyList = res.data.data
                          resolve(res.data.data)
                      } else {
                          reject(res.msg)
                      }
                  })
              })
          },
          query() {
              if (!!this.val.id) {
                  this.$axios.get('/admin/user/detail/' + this.val.id).then(res => { //详情
                      if (res.data) {
                          this.model = res.data.data
                          this.accidentEditAuth = !!this.model.accidentEditAuth
                          this.accidentExamineAuth = !!this.model.accidentExamineAuth
                          this.dingzePoliceAuth = !!this.model.dingzePoliceAuth
                          this.enforcementPoliceAuth = this.model.enforcementPoliceAuth != null && this.model.enforcementPoliceAuth.toLowerCase() == "mini" ? true : false
                          if (this.model.policeStampUrl == null) {
                              this.accidentImg = ''
                          } else if (this.model.policeStampUrl != null && this.model.policeStampUrl.indexOf("https://") != -1) {
                              this.accidentImg = this.model.policeStampUrl
                          } else if (this.model.policeStampUrl != null && this.model.policeStampUrl.indexOf("http://") != -1) {
                              this.accidentImg = this.model.policeStampUrl
                          } else if (this.model.policeStampUrl != null && this.model.policeStampUrl.indexOf("https://") == -1) {
                              this.accidentImg = `${this.model.policeStampUrl}`
                          }
                          this.imgList.push(this.accidentImg)
                          if (this.model.policeContactUrl == null) {
                              this.contactImg = ''
                          } else if (this.model.policeContactUrl != null && this.model.policeContactUrl.indexOf("https://") != -1) {
                              this.contactImg = this.model.policeContactUrl
                          } else if (this.model.policeContactUrl != null && this.model.policeContactUrl.indexOf("http://") != -1) {
                              this.contactImg = this.model.policeContactUrl
                          } else if (this.model.policeContactUrl != null && this.model.policeContactUrl.indexOf("https://") == -1) {
                              this.contactImg = `${this.model.policeContactUrl}`
                          }
                          this.needAuthConfirm = this.model.needAuthConfirm != null && this.model.needAuthConfirm == 1 ? true : false;
                          this.faceDisabled = this.model.faceDisabled != null && this.model.faceDisabled == 1 ? true : false;
                          // this.roleNames = res.data.data.roleNames == null ? [] : res.data.data.roleNames.split(",");
                          this.roleIds = res.data.data.roleIds == null ? [] : res.data.data.roleIds.split(",");
                          this.roleCheckList.forEach(n => {
                              this.roleIds.forEach(m => {
                                  if (n.id == m) {
                                      this.roleNames.push(n.roleName)
                                  }
                              })
                          })
  
                          this.districtIds = res.data.data.districtIds;
  
                          this.model.gender = this.model.gender.toString();
                          if (res.data.data.examineLeaderIds != null) {
                              let names = []
                              let nameids = res.data.data.examineLeaderIds.split(",")
                              this.leaderList.forEach(n => {
                                  nameids.forEach(m => {
                                      if (m == n.id) {
                                          names.push(n.realname)
                                      }
                                  })
                              })
                              this.model.examineLeaderName = names.join()
                          }
                      }
                  })
              }
          },
          saveInformation(formName) { //保存
              let on = false;
              this.$refs['ruleForm'].validate((valid) => {
                  // console.log(valid)
                  on = valid
              });
              if (!on) return;
  
              let accidentEditAuth = Number(this.accidentEditAuth);
              this.model.accidentEditAuth = accidentEditAuth;
              let accidentExamineAuth = Number(this.accidentExamineAuth);
              this.model.accidentExamineAuth = accidentExamineAuth;
              let dingzePoliceAuth = Number(this.dingzePoliceAuth);
              this.model.dingzePoliceAuth = dingzePoliceAuth;
              this.model.enforcementPoliceAuth = this.enforcementPoliceAuth ? "mini" : null;
  
              this.roleIds = [];
              this.roleCheckList.forEach(n => {
                  this.roleNames.forEach(m => {
                      if (n.roleName == m) {
                          this.roleIds.push(n.id)
                      }
                  })
              })
              // console.log(this.roleNames.join())
              // console.log(this.roleIds.join())
              this.model.roleNames = this.roleNames.join();
              this.model.roleIds = this.roleIds.join();
  
              // console.log(this.districtNames)
              // console.log(this.districtIds)
              this.model.districtIds = this.districtIds;
              this.model.needAuthConfirm = this.needAuthConfirm == true ? 1 : 0;
              this.model.faceDisabled = this.faceDisabled == true ? 1 : 0;
              console.log(this.model)
              // return;
              if (!!this.val.id) {
                  this.$axios.post('/admin/user/editUser', this.model).then(res => { //修改
                      this.$emit('func', this.detail)
                      this.$parent.fetchData();
                  })
              } else {
                  this.$axios.post('/admin/user/addUser', this.model).then(res => { //新建
                      console.log(res)
                      if (res.data.data) {
                          this.$emit('func', this.detail)
                          this.$parent.fetchData();
                      } else {
                          this.$message.error(res.data.msg)
                      }
                  })
              }
  
          },
          back() {
              this.$emit('func', this.detail)
          },
          //
          selectRoles() {
              if (this.model.organizationId == null) return this.$message.error("请先选择所属单位！");
              this.roleShow = true
          },
          selectLeader() {
              if (this.val.id == null) return this.$message.error("请先保存用户信息!")
              this.leaderShow = true;
          },
          getleaderList() {
              this.$axios.get('/admin/user/leaderList').then(res => {
                  this.leaderList = res.data.data;
                  this.query()
              })
          },
          passwordBlur() {
              this.$refs['ruleForm'].validate((valid) => {})
          },
          removeCompanyName() {
              this.model.insuranceCompanyName = "";
              this.model.insuranceCompanyId = 0;
              this.$set(this.model, this.model.insuranceCompanyName, "");
              this.$set(this.model, this.model.insuranceCompanyId, 0);
              this.$delete(this.model, this.model.insuranceCompanyName);
              this.$delete(this.model, this.model.insuranceCompanyId);
              console.log(this.model)
          },
          getroleList(id) {
              this.$axios.get('/admin/district/simpList/' + id).then(res => { //角色身份列表
                  let data = res.data.data
                  if (data) {
                      // console.log(data)
                      // console.log(this.districtIds)
                      let str = this.districtIds == null ? [] : this.districtIds.split(",");
                      // console.log(str)
                      let arr = []
                      data.forEach(n => {
                          str.forEach(m => {
                              if (n.id == m) {
                                  arr.push(n.districtName);
                              }
                          })
                      })
                      this.districtNames = arr.join();
                  }
              })
          },
  
      }
  }
  </script>
  
  <style lang="scss" scoped>
  .main {
      display: flex;
      background: #fff;
      flex-direction: row;
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      z-index: 100;
      flex-direction: column;
      box-sizing: border-box;
  
      .maskTitle {
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          /*position: fixed;*/
          /*top: 50px;*/
          justify-content: space-between;
          width: calc(100%);
          box-sizing: border-box;
          padding: 10px;
          background: #ccc;
          z-index: 100;
      }
  
      .leftContent {
          /*height: 100%;*/
          /*overflow-y: scroll;*/
          box-sizing: border-box;
          text-align: left;
          width: calc(100%);
          margin-right: 10px;
          float: left;
          padding-bottom: 50px;
  
          .tableContent {
              margin-top: 10px;
              border: 1px solid #f4f5f7;
          }
  
          .userImages {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              margin-top: 20px;
  
              .img-box {
                  margin-right: 10px;
                  margin-bottom: 10px;
              }
          }
  
          .wholeAcccindentClass {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              flex-wrap: wrap;
  
              .accidentImages {
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
  
                  .images {
                      display: flex;
                      align-items: center;
                      justify-content: flex-start;
                      flex-direction: column;
                      height: 120px;
                      margin-top: 20px;
                      margin-right: 10px;
                      margin-bottom: 10px;
  
                      .img-box {
                          margin: 0 auto;
                          margin-bottom: 10px;
                      }
                  }
              }
          }
  
      }
  
      .personInfo {
          .title {
              line-height: 40px;
              background: #ccc;
              display: flex;
              align-items: center;
              justify-content: space-between;
              box-sizing: border-box;
              padding: 0px 10px;
          }
  
          .wholePersonClass {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              flex-wrap: wrap;
  
              .accidentImages {
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
  
                  .images {
                      display: flex;
                      align-items: center;
                      justify-content: flex-start;
                      flex-direction: column;
                      height: 120px;
                      margin-top: 20px;
                      margin-right: 10px;
                      margin-bottom: 10px;
  
                      .img-box {
                          margin: 0 auto;
                          margin-bottom: 10px;
                      }
                  }
              }
          }
      }
  
      .bottomBtns {
          width: 100%;
          position: fixed;
          left: 0px;
          bottom: 0px;
          background: #ccc;
          margin-bottom: 0px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
      }
  
      .right /deep/ .el-form-item__error {
          padding-top: 0;
      }
  
      .checkcase {
          width: 200px !important;
          display: table !important;
      }
  
      .wholeAcccindentClass /deep/ .el-icon-zoom-in:before {
          content: none;
      }
  
  }
  </style>
  


// WEBPACK FOOTER //
// detail.vue?ab8874da